import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import swal from "sweetalert";
import WorkProcess from "./WorkProcess";
import CustomLoader from "../static/CustomLoader";
import {
  MasterPage,
  MasterToolbar,
  MasterButton,
  MasterSearch,
  MasterGrid,
  MasterDialog,
  MasterConfirmDialog,
} from "../static/Masterpage";

const WorkProcessListing = () => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };

  const [loading, setLoading] = useState(false);
  const [density, setDensity] = useState("standard");
  const [divCdList, setDivCdList] = useState([{}]);
  const [workProcessData, setWorkProcessData] = useState([{}]);
  const [serach, setSerach] = useState("");
  const [selectedData, setSelectedData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [filterData, setFilterData] = useState([{}]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [addShow, setAddShow] = useState(false);
  const [editShow, setEditShow] = useState(false);

  const columns = [
    {
      field: "code",
      headerName: "Code",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "divcd",
      headerName: "Department",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const typeOption = divCdList.find(
          (option) => option.value === params.value,
        );
        return typeOption ? typeOption.label : params.value;
      },
    },
    {
      field: "completiontime",
      headerName: "Completion Time",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
  ];

  useEffect(() => {
    fetchData();
    fetchDivision();
  }, [refresh]);

  const fetchData = async () => {
    try {
      setLoading(true);
      axios
        .get(apiUrl + "workprocess", { headers })
        .then((response) => {
          setWorkProcessData(response.data);
          setFilterData(response.data);
          setRefresh(false);
          setSelectedData([]);
          setLoading(false);
        })
        .catch((error) => {
          console.log("error " + error);
          setWorkProcessData([{}]);
          setLoading(false);
        });
    } catch (error) {
      setWorkProcessData([{}]);
      setLoading(false);
    }
  };

  const fetchDivision = async () => {
    try {
      setLoading(true);
      axios
        .get(apiUrl + "division", { headers })
        .then((response) => {
          const sectionOption = response.data.map((op) => ({
            value: op.code,
            label: op.name,
          }));
          setDivCdList(sectionOption);
          setLoading(false);
        })
        .catch((error) => {
          console.log("error " + error);
          setDivCdList([{}]);
          setLoading(false);
        });
    } catch (error) {
      setDivCdList([{}]);
      setLoading(false);
    }
  };

  const handlesearch = (event) => {
    const getSearch = event.target.value.toLowerCase();
    if (getSearch.length > 0) {
      const searchdata = filterData.filter((item) =>
        Object.keys(item).some((key) =>
          String(item[key]).toLowerCase().includes(getSearch),
        ),
      );
      setWorkProcessData(searchdata);
    } else {
      setWorkProcessData(filterData);
    }
    setSerach(getSearch);
  };

  const addHandleShow = () => {
    setAddShow(true);
  };

  const addHandleClose = () => {
    setShowConfirm(true);
  };

  const editHandleShow = () => {
    if (selectedData.length > 1 || selectedData.length === 0) {
      toast.warning("Please Select only one value");
      return;
    }
    setEditShow(true);
  };

  const editHandleClose = () => {
    setShowConfirm(true);
  };

  const handleConfirmClose = () => {
    setShowConfirm(false);
    setAddShow(false);
    setEditShow(false);
  };

  const handleCancelClose = () => {
    setShowConfirm(false);
  };

  const RemoveFunction = async () => {
    if (selectedData) {
      swal({
        title: "Do you want to remove?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (confirmDelete) => {
        if (confirmDelete) {
          setLoading(true);
          try {
            await axios
              .delete(apiUrl + "workprocess/" + selectedData[0], { headers })
              .then((response) => {
                toast.success("Record removed successfully.");
                fetchData();
                setLoading(false);
              });
          } catch (error) {
            console.error("Error deleting record:", error);
            setLoading(false);
          }
        }
      });
    } else {
      toast.warning("Please Select at least one value");
      setLoading(false);
    }
  };

  return (
    <>
      <MasterPage>
        <MasterToolbar
          actions={
            <>
              <MasterButton
                variant="add"
                tooltip="Create new Work Process"
                onClick={addHandleShow}
                disabled={loading}
              >
                Add
              </MasterButton>
              <MasterButton
                variant="update"
                tooltip="Edit Selected Work Process"
                onClick={editHandleShow}
                disabled={loading}
              >
                Update
              </MasterButton>
              <MasterButton
                variant="danger"
                tooltip="Delete Selected Work Process"
                onClick={RemoveFunction}
                disabled={loading}
              >
                Delete
              </MasterButton>
            </>
          }
          search={
            <MasterSearch
              tooltip="Search by All"
              value={serach}
              onChange={handlesearch}
              inputRef={(input) => input && input.focus()}
            />
          }
        />

        <MasterGrid
          density={density}
          onDensityChange={(newDensityString) => setDensity(newDensityString)}
          rows={
            workProcessData !== null &&
            workProcessData.length > 0 &&
            Object.keys(workProcessData[0]).length !== 0 &&
            workProcessData
          }
          columns={columns}
          onSelectionModelChange={(ids) => setSelectedData(ids)}
        />
      </MasterPage>

      {loading && <CustomLoader />}

      <MasterDialog
        open={addShow}
        onHide={addHandleClose}
        title="Add Work Process"
      >
        <WorkProcess
          selectedId=""
          mode="A"
          onHide={addHandleClose}
          setRefresh={setRefresh}
        />
      </MasterDialog>

      <MasterDialog
        open={editShow}
        onHide={editHandleClose}
        title="Edit Work Process"
      >
        <WorkProcess
          selectedId={selectedData && selectedData[0]}
          mode="U"
          onHide={editHandleClose}
          setRefresh={setRefresh}
        />
      </MasterDialog>

      <MasterConfirmDialog
        show={showConfirm}
        title="Close Confirmation"
        message="Are you sure you want to close this modal?"
        onConfirm={handleConfirmClose}
        onCancel={handleCancelClose}
      />
    </>
  );
};

export default WorkProcessListing;
